// @ts-nocheck

const ReactDOM = require('react-dom');
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DEPRECATED_FilterActions from 'app/shared/flux/actions/DEPRECATED_FilterActions';
import IconArrowGrey from 'images/icons/arrow-grey.svg';
import Modal from 'app/shared/modules/Modal';
import * as S from 'app/shared/modules/filter/ButtonDropdown/styles';
import constants from 'app/shared/constants/ConstantsBundle';

const { bool, func, node, string } = PropTypes;

class ButtonDropdown extends React.Component {
  static propTypes = {
    canClose: bool,
    children: node,
    className: string,
    contentDataName: string,
    contentTestId: string,
    dropdownRight: bool,
    doneButtonAriaLabel: string,
    doneButtonDataName: string,
    doneButtonTestId: string,
    forceOverlay: bool,
    forceNoOverlay: bool,
    isOpen: bool,
    label: string,
    noBorder: bool,
    onClose: func,
    onToggleOverrideClose: func,
    showDoneButton: bool,
    size: string,
    theme: string,
    triggerAriaLabel: string,
    triggerDataName: string,
    triggerTestId: string,
  };
  static defaultProps = {
    canClose: true,
    children: '',
    className: '',
    contentDataName: '',
    contentTestId: '',
    dropdownRight: false,
    doneButtonAriaLabel: '',
    doneButtonDataName: '',
    doneButtonTestId: '',
    forceOverlay: true,
    forceNoOverlay: false,
    isOpen: false,
    label: '',
    onClose: () => {},
    noBorder: false,
    onToggleOverrideClose: () => {},
    showDoneButton: false,
    size: 'sm',
    theme: 'default',
    triggerAriaLabel: '',
    triggerDataName: '',
    triggerTestId: '',
  };
  constructor(props) {
    super(props);
    const { isOpen } = this.props;
    this.state = {
      isOpen,
    };
    this.dropdownButton = React.createRef();
    this.containerRef = React.createRef();
    this.toggleGen = 0;
  }
  componentDidMount() {
    window.addEventListener('mousedown', this.handleMouseDown);
    window.addEventListener('touchstart', this.handleMouseDown);
  }
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleMouseDown);
    window.removeEventListener('touchstart', this.handleMouseDown);
  }
  handleClickToggle = () => {
    const expectedGen = ++this.toggleGen;
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (this.toggleGen !== expectedGen) return;
        const { isOpen } = this.state;
        this.setState({
          isOpen: !isOpen,
        });
      }, 0);
    });
  };
  handleMouseDown = (e) => {
    const { onClose } = this.props;
    if (this.state.isOpen && this.containerRef.current && !this.containerRef.current.contains(e.target)) {
      this.toggleGen++;
      this.handleCloseDropdown(e, onClose);
    }
  };
  handleCloseDropdown = (e, onClose = () => {}) => {
    const { onToggleOverrideClose, canClose } = this.props;
    if (canClose) {
      onClose();
      this.setState({
        isOpen: false,
      });

      return;
    }
    // only block closing once - after the user has seen the error, set canClose to true
    onToggleOverrideClose();
  };
  handleRemoveFilterItem = (e) => {
    const { filterKeys, dispatch } = this.props;
    e.stopPropagation();

    dispatch(DEPRECATED_FilterActions.partialResetFilter({ keys: filterKeys }));
    this.handleCloseDropdown();
  };
  handleKeyDown = (e) => {
    const { shiftKey, which } = e;
    // if user opens the dropdown, then immediately back tabs, the dropdown should close
    if (shiftKey && which === constants.TAB_KEYCODE) {
      this.handleCloseDropdown();
    }
  };
  handleDoneButtonKeyDown = (e) => {
    const { which } = e;
    // collapse dropdown when tabbing out
    if (which === constants.TAB_KEYCODE) {
      this.handleCloseDropdown();
    }
  };
  handleDoneButtonClick = (e) => {
    e.stopPropagation();
    this.toggleGen++;
    this.handleCloseDropdown(e);
    this.dropdownButton.current.focus();
  };
  render() {
    const {
      children,
      className,
      dropdownRight,
      filterKeys,
      forceOverlay,
      forceNoOverlay,
      label,
      noBorder,
      showDoneButton,
      size,
      theme,
      contentDataName,
      contentTestId,
      doneButtonAriaLabel,
      doneButtonDataName,
      doneButtonTestId,
      triggerAriaLabel,
      triggerDataName,
      triggerTestId,
    } = this.props;
    const { isOpen } = this.state;
    const rest = omit(this.props, [
      'canClose',
      'onClose',
      'children',
      'className',
      'dispatch',
      'dropdownRight',
      'filterKeys',
      'forceOverlay',
      'forceNoOverlay',
      'isOpen',
      'label',
      'noBorder',
      'onClick',
      'onToggleOverrideClose',
      'showDoneButton',
      'size',
      'theme',
      'contentDataName',
      'contentTestId',
      'doneButtonAriaLabel',
      'doneButtonDataName',
      'doneButtonTestId',
      'triggerAriaLabel',
      'triggerDataName',
      'triggerTestId',
      'zIndexOnTop',
    ]);

    return (
      <S.ButtonDropdown className={className} theme={theme} ref={this.containerRef} {...rest}>
        <S.ButtonDropdownClickable
          size={size}
          onClick={this.handleClickToggle}
          aria-label={triggerAriaLabel || undefined}
          aria-expanded={isOpen}
          onKeyDown={this.handleKeyDown}
          ref={this.dropdownButton}
          data-name={triggerDataName || undefined}
          data-testid={triggerTestId || undefined}
        >
          {label && <S.Text size={size === 'lg' ? 'md' : 'sm'}>{label}</S.Text>}
          <S.ButtonDropdownArrow isOpen={isOpen} src={IconArrowGrey} size={size} alt="" />
        </S.ButtonDropdownClickable>
        {isOpen && (
          <Modal
            onHidePopup={this.handleCloseDropdown}
            modalNavOffset
            forceOverlay={forceOverlay}
            forceNoOverlay={forceNoOverlay}
          >
            <S.ButtonDropdownDropdownContent
              noBorder={noBorder}
              dropdownRight={dropdownRight}
              data-name={contentDataName || undefined}
              data-testid={contentTestId || undefined}
            >
              {filterKeys && <S.ButtonDropdownReset onClick={this.handleRemoveFilterItem}>Reset</S.ButtonDropdownReset>}
              {children}
              {showDoneButton && (
                <S.ButtonDropdownDoneBtn>
                  <S.ButtonDropdownDoneBtnSm
                    aria-label={doneButtonAriaLabel || undefined}
                    onClick={this.handleDoneButtonClick}
                    onKeyDown={this.handleDoneButtonKeyDown}
                    data-name={doneButtonDataName || undefined}
                    data-testid={doneButtonTestId || undefined}
                  >
                    Done
                  </S.ButtonDropdownDoneBtnSm>
                </S.ButtonDropdownDoneBtn>
              )}
            </S.ButtonDropdownDropdownContent>
          </Modal>
        )}
      </S.ButtonDropdown>
    );
  }
}

export default connect()(ButtonDropdown);
